import dayjs from 'dayjs';

import { VenueMonthDeclaration } from '@/domain/project-venue-month-declaration/entities/project-venue-month-declaration';
import { formatDateToYearMonth } from '@/domain/utils/format-date-to-year-month';

import { MonthDeclarationDto } from './dto.schema';

export class MonthDeclarationsMapper {
  static dtoToEntity(dto: MonthDeclarationDto[]): {
    [monthKey: string]: VenueMonthDeclaration;
  } {
    const monthDeclarations = dto.reduce((acc, cur) => {
      const date = dayjs(`${cur.year}-${cur.month}`);
      const formatedDate = formatDateToYearMonth(date.toDate());
      const entry = {
        id: cur.id,
        co2: cur.co2,
      };
      return { ...acc, [formatedDate]: entry };
    }, {});
    return monthDeclarations;
  }

  static entityToDto(
    monthDeclaration: VenueMonthDeclaration,
    monthKey: string,
  ): Omit<MonthDeclarationDto, 'seasonId'> {
    return {
      id: monthDeclaration.id,
      month: getMonthInNumber(monthKey),
      year: getYearInNumber(monthKey),
      co2: monthDeclaration.co2,
    };
  }
}

function getMonthInNumber(month: string) {
  return new Date(month).getMonth() + 1;
}

function getYearInNumber(month: string) {
  return new Date(month).getFullYear();
}
